import { YStack, XStack, Text } from 'tamagui'
import type { StepsSlide as StepsSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor, getAccentGlow, parseLinkedText } from './shared'

export function StepsSlide({ slide }: { slide: StepsSlideType }) {
  const accentColor = getAccentColor(slide.accent)
  return (
    <SlideContainer>
      <SlideInner style={{ padding: 'clamp(32px, 6vw, 80px)' }}>
        {slide.headline && (
          <Text
            fontFamily="$heading"
            fontWeight="700"
            color={accentColor}
            style={{ fontSize: 'clamp(24px, 3.5vw, 44px)', lineHeight: '1.2em' }}
          >
            {slide.headline}
          </Text>
        )}
        <YStack gap="$5" marginTop="$6">
          {slide.steps.map((step, i) => (
            <XStack key={i} gap="$4" alignItems="center">
              <Text
                fontFamily="$mono"
                color={step.done ? '#22C55E' : accentColor}
                style={{ fontSize: 'clamp(16px, 2vw, 24px)', width: '40px' }}
              >
                {step.done ? '✓' : `${String(i + 1).padStart(2, '0')}`}
              </Text>
              <Text
                fontFamily="$body"
                color={step.done ? '$textMuted' : '$textSecondary'}
                style={{
                  fontSize: 'clamp(14px, 1.8vw, 22px)',
                  textDecoration: step.done ? 'line-through' : 'none',
                }}
              >
                {parseLinkedText(step.text)}
              </Text>
            </XStack>
          ))}
        </YStack>
        {slide.prompt && (
          <Text
            fontFamily="$mono"
            color="$textMuted"
            fontStyle="italic"
            marginTop="$6"
            style={{ fontSize: 'clamp(12px, 1.5vw, 18px)' }}
          >
            {slide.prompt}
          </Text>
        )}
        {slide.linkText && slide.href && (
          <YStack
            tag="a"
            // @ts-ignore
            href={slide.href}
            target="_blank"
            rel="noopener noreferrer"
            paddingHorizontal="$6"
            paddingVertical="$3"
            borderRadius="$3"
            borderWidth={1}
            borderColor={accentColor}
            marginTop="$4"
            alignSelf="flex-start"
            cursor="pointer"
            hoverStyle={{ backgroundColor: `${accentColor}15` }}
            style={{ textDecoration: 'none' }}
          >
            <Text fontFamily="$mono" color={accentColor} style={{ fontSize: 'clamp(12px, 1.5vw, 18px)' }}>
              {slide.linkText}
            </Text>
          </YStack>
        )}
      </SlideInner>
    </SlideContainer>
  )
}
